import actionTypes from "../common/actionTypes";
import { DATABASE_STATUTES } from "../common/constants";

export const settingReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SETTINGS:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
        data: [],
      };

    case actionTypes.FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.FETCH_SETTINGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };
    default:
      return state;
  }
};
